module.exports = __webpack_public_path__ + "static/img/1.48b91797.png";